import { ToastContainer } from 'react-toastify';
import { toastConfig } from '../config/toast.config';

interface PageLayoutProps {
  children: React.ReactNode;
  title: string;
  description?: string;
}

export const PageLayout = ({ children, title, description }: PageLayoutProps) => {
  return (
    <div className='w-[65%] m-auto'>
      <ToastContainer {...toastConfig} />
      <div className='mb-12 mt-20 flex flex-col gap-10'>
        <h1 className='text-primary-600 text-3xl font-semibold'>{title}</h1>
        {description && <p className='text-primary-500'>{description}</p>}
      </div>
      {children}
    </div>
  );
};
